import { ConfigurationType } from 'civil-status/constants/configuration-type';
import { SectionVM, TrascrizioneMorte } from 'civil-status/view-models/step-form';

export const transformerTrascrizioneMorte = (
  dataSection?: SectionVM,
  dataUltimoLuogo?: SectionVM,
  idEvento?: number
): TrascrizioneMorte | undefined => {
  if (!(dataSection || dataUltimoLuogo)) {
    return undefined;
  }

  return {
    key: idEvento
      ? {
          idEvento,
        }
      : undefined,
    dataComunicazione: dataSection?.dateTranscription
      ? dataSection?.dateTranscription?.toFormat('yyyy-MM-dd')
      : undefined,
    trascrizione: dataSection?.templateTranscriptionText || undefined,
    dichiarazione:
      dataSection?.configuration === ConfigurationType.TRATXTSCR ||
      dataSection?.configuration === ConfigurationType.TRASCRTISC
        ? '3'
        : undefined,
    tipoScomparsa: dataSection?.typeDisappearance || undefined,
    dataUltimoAvvistamento: dataUltimoLuogo?.dateLastSighting
      ? dataUltimoLuogo.dateLastSighting.toFormat('yyyy-MM-dd')
      : undefined,
  };
};
